"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcPopOverConstans = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var BC_POP_OVER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-pop-over");
var BcPopOverConstans = (function () {
    function BcPopOverConstans() {
    }
    BcPopOverConstans.BC_POP_OVER = "".concat(BC_POP_OVER);
    BcPopOverConstans.BC_POP_OVER_CONTAINER = "".concat(BC_POP_OVER, "-container");
    BcPopOverConstans.BC_POP_OVER_ACTIVE = "".concat(BC_POP_OVER, "-active");
    BcPopOverConstans.BC_POP_OVER_TARGET = "".concat(BC_POP_OVER, "-target");
    BcPopOverConstans.BC_POP_OVER_ARROW = "".concat(BC_POP_OVER, "-arrow");
    BcPopOverConstans.BC_POP_OVER_GRAY = "".concat(BC_POP_OVER, "-gray");
    BcPopOverConstans.BC_POP_OVER_CONTENT_CLOSE = "".concat(BC_POP_OVER, "-content-close");
    BcPopOverConstans.BC_POP_OVER_ATRIBUTE_BUTTON_CLOSE = 'buttonClose';
    BcPopOverConstans.BC_POP_OVER_BACKDROP = "".concat(BC_POP_OVER, "-backdrop");
    BcPopOverConstans.BC_POP_OVER_SCROLL = "".concat(BC_POP_OVER, "-scroll");
    BcPopOverConstans.BC_POP_OVER_SCROLL_BLOCK = "".concat(BC_POP_OVER, "-scroll-block");
    BcPopOverConstans.BC_POP_OVER_SCROLL_HIGHLIGHT = "".concat(BC_POP_OVER, "-highlight");
    BcPopOverConstans.BC_POP_OVER_PROPERTY_WIDTH = 'width';
    BcPopOverConstans.BC_POP_OVER_PROPERTY_TYPE_WIDTH = 'typeWidth';
    BcPopOverConstans.BC_POP_OVER_PROPERTY_HEIGHT = 'height';
    BcPopOverConstans.BC_POP_OVER_PROPERTY_TYPE_HEIGHT = 'typeHeight';
    BcPopOverConstans.BC_POP_OVER_PROPERTY_BACKDROP = 'backdrop';
    BcPopOverConstans.BC_POP_OVER_PROPERTY_FULLSCREEN = 'fullScreen';
    BcPopOverConstans.BC_POP_OVER_PROPERTY_HOVER = 'hover';
    BcPopOverConstans.BC_POP_OVER_PROPERTY_CLOSE_OUTSIDE = 'closeOutside';
    BcPopOverConstans.BC_POP_OVER_PROPERTY_HIDDEN_ARROW = 'hiddenArrow';
    BcPopOverConstans.BC_POP_OVER_VALUE_TRUE = 'true';
    BcPopOverConstans.BC_POP_OVER_ICON_ERROR = 'error';
    BcPopOverConstans.BC_POP_OVER_CONTAINER_MIN_WIDTH = 140;
    return BcPopOverConstans;
}());
exports.BcPopOverConstans = BcPopOverConstans;
